import { createIcon } from './create-icon'

export const MoreO = createIcon({
  displayName: 'MoreO',
  paths: [
    'M128 512c0-212.096 171.904-384 384-384s384 171.904 384 384c0 212.096-171.904 384-384 384s-384-171.904-384-384zM832 512c0-176.469-143.531-320-320-320s-320 143.531-320 320c0 176.469 143.531 320 320 320s320-143.531 320-320zM640 512c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667zM512 469.333c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667zM298.667 512c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667c0 23.552-19.115 42.667-42.667 42.667s-42.667-19.115-42.667-42.667z'
  ]
})
